import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { useContext, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ThemeContext } from '../ThemeContext/ThemeContext';
import { hideSessionExpiredModal, logOut } from '../../redux/user/user.actions';
import { resetSessionExpiredFlag } from '../../services/http';

const SessionExpiredModal = ({ isOpen }) => {
  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const handleConfirm = useCallback(() => {
    dispatch(hideSessionExpiredModal());
    resetSessionExpiredFlag();
    // logOut() já faz o redirecionamento para /login
    dispatch(logOut());
  }, [dispatch]);

  // Auto-redireciona após 5 segundos se o usuário não fechar o modal
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        handleConfirm();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, handleConfirm]);

  const handleClose = () => {
    // Não permite fechar o modal clicando fora ou no X
    // O usuário deve clicar em "Entendi" ou aguardar o timeout
    return;
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: theme.palette.background.default,
          borderRadius: '15px',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
        }
      }}
    >
      <DialogTitle sx={{ 
        color: theme.palette.error.main,
        fontWeight: 'bold',
        fontSize: '1.5rem'
      }}>
        Sessão Expirada
      </DialogTitle>
      <DialogContent>
        <Typography 
          sx={{ 
            color: theme.palette.text.secondary,
            marginTop: '0.5rem',
            fontSize: '1rem'
          }}
        >
          Sua sessão expirou por inatividade. Por favor, faça login novamente para continuar.
        </Typography>
        <Typography 
          sx={{ 
            color: theme.palette.text.secondary,
            marginTop: '1rem',
            fontSize: '0.875rem',
            fontStyle: 'italic'
          }}
        >
          Você será redirecionado para a tela de login em alguns segundos...
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', margin: '1rem 0', padding: '0 1.5rem 1.5rem' }}>
        <Button
          variant="contained"
          color="primary"
          sx={{
            borderRadius: '10px',
            textTransform: 'capitalize',
            padding: '0.5rem 2rem',
            fontSize: '1rem'
          }}
          onClick={handleConfirm}
        >
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredModal;
